// extracted by mini-css-extract-plugin
export default {"container":"autoSelect_container__6VxS7","content":"autoSelect_content__IsAdp","sideMenu":"autoSelect_sideMenu__BqLml"};